export default "__VITE_ASSET__sPFrU3Pt__"